<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import {
  mobileContactOverlayClasses,
  mobileFloatingActionButtonClasses,
} from 'dashboard/constants/mobileFloatingActionButton';

const props = defineProps({
  canManageDirectory: { type: Boolean, default: false },
  canCreateContact: { type: Boolean, default: false },
});
const emit = defineEmits(['add', 'import', 'export']);

const { t } = useI18n();

const contactMenuItems = computed(() => {
  const items = [];
  if (props.canCreateContact) {
    items.push({
      label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.ADD_CONTACT'),
      action: 'add',
      value: 'add',
      icon: 'i-lucide-plus',
    });
  }
  if (props.canManageDirectory) {
    items.push(
      {
        label: t(
          'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.EXPORT_CONTACT'
        ),
        action: 'export',
        value: 'export',
        icon: 'i-lucide-upload',
      },
      {
        label: t(
          'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.IMPORT_CONTACT'
        ),
        action: 'import',
        value: 'import',
        icon: 'i-lucide-download',
      }
    );
  }
  return items;
});
const showActionsDropdown = ref(false);

const handleContactAction = ({ action }) => {
  if (action === 'add') {
    emit('add');
  } else if (action === 'import') {
    emit('import');
  } else if (action === 'export') {
    emit('export');
  }
};
</script>

<template>
  <div
    v-show="contactMenuItems.length"
    v-on-clickaway="() => (showActionsDropdown = false)"
    class="relative"
  >
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      class="max-md:!text-[#525252]"
      :class="[
        mobileFloatingActionButtonClasses,
        showActionsDropdown ? 'bg-n-alpha-2 max-md:!text-[#15603e]' : '',
      ]"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="contactMenuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      :class="mobileContactOverlayClasses"
      @action="handleContactAction($event)"
    />
  </div>
</template>
